import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import { Fade } from 'react-reveal';
import { Actions } from '../../flux';
import { images, texts, relacionamentos } from '../../settings';
import { DelayLink, SliderText } from '../../components';

import './Relacionamentos.scss';

class Relacionamentos extends Component {
  constructor(props) {
    super(props);

    this.state = {
      width: window.innerWidth,
      selected: 'nacionais',
      items: [],
    };

    this.contentText = React.createRef();
  }

  scrollTop = () => {
    window.scrollTo({ top: this.contentText.current.offsetTop });
  };

  componentDidMount = () => {
    Actions.headerIntern();
    this.scrollTop();

    this.setState({
      items: relacionamentos[this.state.selected],
    });
  };

  changeItems = label => {

    this.setState({
      selected: label,
      items: relacionamentos[label],
    });
  };

  render = () => {
    const { selected, items } = this.state;

    return (
      <div className="views" ref={this.contentText}>
        <Helmet>
          <title>Relacionamentos - {texts.title}</title>
        </Helmet>

        <div
          className="relacionamentos-home page-gradient page-gradient--blue bg-light-blue"
          ref="relacionamentos-home"
        >
          <section className="relacionamentos-home-area page-gradient__header">
            <div class="row">
              <div class="container white">
                <h1 className="page-header__title gri_text gri_text--fixed my-0">
                  <img src={images.relacionamentos.shape} className="shape" />
                  Relacionamentos
                  <span className="gri_label">
                    GRI <b>102-12, 102-13, 102-42, 102-43, 103-1, 103-2, 103-3 | 203</b>
                  </span>
                </h1>
              </div>
            </div>
            <div className="container bg-white">
              <div className="row flex-v-center">
                <div className="col-5">
                  <Fade bottom>
                    <div className="page-header">
                      <p className="page-header__description gri_text text-format">
                        Em 2020, mantivemos nossa ampla rede de relacionamentos com diferentes instituições públicas e
                        privadas, com contatos virtuais por causa da pandemia.
                        <br />
                        <br />A interlocução com esses agentes contribui para o nosso trabalho de desenvolver e
                        fortalecer o mercado.
                      </p>
                    </div>
                  </Fade>
                </div>

                <div className="col-7 col-image">
                  <img src={images.relacionamentos.pessoas} className="pessoas" />
                </div>
              </div>
            </div>
          </section>

          <section className="page--blue relacionamentos-body">
            <div className="row">
              <div className="container flex-column">
                <div className="governanca-body__content container">
                  <Fade bottom>
                    <h1 className="my-0">Confira nossa rede de relacionamentos</h1>
                  </Fade>
                </div>

                <div className="governanca-body__content">
                  <Fade bottom>
                    <div className="relacionamentos_switch my-0">
                      <h3
                        className={selected == 'nacionais' ? `active` : ``}
                        onClick={() => this.changeItems('nacionais')}
                      >
                        Nacionais
                      </h3>
                      <h3
                        className={selected == 'internacionais' ? `active` : ``}
                        onClick={() => this.changeItems('internacionais')}
                      >
                        Internacionais
                      </h3>
                    </div>
                  </Fade>

                  <Fade bottom>
                    <div className="relacionamentos_switch__content">
                      <SliderText items={items} color={'blue'} />
                    </div>
                  </Fade>
                </div>
              </div>
            </div>
          </section>

          <section className="relacionamentos-footer-area">
            <div className="container">
              <div className="row">
                <div className="col-12">
                  <Fade>
                    <div className="box-pill box-pill--green box-pill--center">
                      <div className="box-pill__content box-pill__content--full">
                        <div className="row">
                          <div className="col col-12 col--text">
                            <h4>Veja as principais iniciativas que desenvolvemos em 2020</h4>
                            <DelayLink
                              to="/estrategias/nosso-ano"
                              className="button button--aylen button--white-to-green button--border-medium button--size-m button--round-l button--text-thick"
                            >
                              Saiba mais
                            </DelayLink>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Fade>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    );
  };
}

export { Relacionamentos };
